import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EditPanel from './EditPanel';

const EditPanelWrapper: React.FC = () => {
  const { username } = useParams<{ username: string }>();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/editor');
  };

  return username ? (
    <EditPanel chosen={username} onClose={handleClose} />
  ) : (
    <div>User not found</div>
  );
};

export default EditPanelWrapper;
